// A trip made in the app (D2), as the Pack every screen reads: the kit bundle's places, decks,
// theme and climate, the trip's own name and dates, and one starter stage covering the whole trip
// (the parent splits it into stages in /plan; those are ordinary trip.* events).
import type { KitBundle } from './kits'
import { Pack } from './schema'

export interface AppTrip {
  id: string
  title: string
  startDate: string
  endDate: string
  timezone: string
}

/** The kit id of a "Somewhere else" trip (B3): no kit, no language, the neutral machine. */
export const NO_KIT = 'elsewhere'

/**
 * A trip with no kit ("Somewhere else", B3): one stage over its dates on the placeholder island,
 * no places, no decks (so no Learn; the Arcade plays Explorer) and no climate. The parent names
 * the stage and finds its place in the stage editor (trip.stage.set events, as for any trip).
 */
export function composeElsewhere(trip: AppTrip): Pack {
  return Pack.parse({
    meta: { id: trip.id, version: 1, kit: NO_KIT, title: trip.title, timezone: trip.timezone, startDate: trip.startDate, endDate: trip.endDate, climatology: {}, daylight: { sunrise: '07:00', sunset: '19:00' } },
    theme: { colors: {} },
    itinerary: {
      stages: [{ id: 'stage-1', regionId: 'elsewhere', name: trip.title, shortName: trip.title.slice(0, 12), startDate: trip.startDate, endDate: trip.endDate, anchor: [0, 0], color: 'teal', spot: 'generic' }],
      legs: [],
      dayItems: [],
    },
    places: [],
    decks: [],
  })
}

export function composeTrip(kit: KitBundle, trip: AppTrip): Pack {
  const region = Object.keys(kit.climatology)[0] ?? kit.places[0]?.regionId ?? 'region'
  const anchor = kit.places.find((p) => p.regionId === region)?.at ?? kit.places[0]?.at ?? [0, 0]
  return Pack.parse({
    meta: {
      id: trip.id,
      version: kit.version,
      title: trip.title,
      timezone: trip.timezone,
      startDate: trip.startDate,
      endDate: trip.endDate,
      climatology: kit.climatology,
      daylight: kit.daylight,
      locale: kit.language.locale,
      scripts: kit.language.scripts,
      ...(kit.language.readName ? { readName: kit.language.readName } : {}),
      kit: kit.id,
      ...(kit.reward ? { reward: kit.reward } : {}),
      ...(kit.currency ? { currency: kit.currency } : {}),
    },
    theme: kit.theme,
    itinerary: {
      stages: [
        {
          id: 'stage-1',
          regionId: region,
          name: trip.title,
          shortName: trip.title.slice(0, 12),
          startDate: trip.startDate,
          endDate: trip.endDate,
          anchor,
          color: 'blue',
          spot: kit.islands[0] ?? 'generic',
        },
      ],
      legs: [],
      dayItems: [],
    },
    places: kit.places,
    decks: [...kit.decks].sort((a, b) => a.order - b.order),
  })
}
